import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "password"]
  static values = {
    minLength: { type: Number, default: 8 },
    requireSpecial: { type: Boolean, default: true },
    requireNumber: { type: Boolean, default: true }
  }

  connect() {
    this.submitTarget.disabled = true
    this.updateSubmitButton()
  }

  validate() {
    this.updateSubmitButton()
  }

  isPasswordValid(password) {
    if (!password) return false

    const hasMinLength = password.length >= this.minLengthValue
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
    const hasNumber = /\d/.test(password)

    return hasMinLength &&
           (!this.requireSpecialValue || hasSpecialChar) &&
           (!this.requireNumberValue || hasNumber)
  }

  updateSubmitButton() {
    const password = this.passwordTarget?.value || ""
    const confirmInput = this.element.querySelector('[data-password-validation-target="confirm"]')
    const confirm = confirmInput ? confirmInput.value : ""

    const passwordValid = this.isPasswordValid(password)
    const passwordsMatch = !confirmInput || password === confirm

    this.submitTarget.disabled = !(passwordValid && passwordsMatch)
  }
}
